module.exports = "pegasus_template/assets/tech/valentine/101.png";